<div class="task-package-step-container">
  <dx-scroll-view>
    @for (phase of phases; track $index) {
      @if (phase.title && hasValidMilestones(phase)) {
        <div class="display-node-section">
          <div class="display-node-header" (click)="togglePhaseExpansion(phase)">
            <app-svg-icon
              icon="chevron-down"
              [strokeWidth]="2"
              color="var(--color-grey-700)"
              class="expand-icon"
              [class.expanded]="isPhaseExpanded(phase)"
            ></app-svg-icon>
            <app-svg-icon
              icon="route"
              color="var(--color-green-500)"
              class="display-node-icon"
              [size]="20"
            ></app-svg-icon>
            <span class="display-node-title">{{ phase.title }}</span>
          </div>

          <div class="display-node-content" *ngIf="isPhaseExpanded(phase)">
            @for (milestone of phase.milestones || []; track $index) {
              @if (milestone.name) {
                <div class="display-node-section">
                  <div class="display-node-header" (click)="toggleMilestoneExpansion(milestone)">
                    <app-svg-icon
                      icon="chevron-down"
                      [strokeWidth]="2"
                      color="var(--color-grey-600)"
                      class="expand-icon"
                      [class.expanded]="isMilestoneExpanded(milestone)"
                    ></app-svg-icon>
                    <app-svg-icon
                      icon="flag"
                      color="var(--color-primary)"
                      class="display-node-icon"
                      [size]="18"
                    ></app-svg-icon>
                    <span class="display-node-title">{{ milestone.name }}</span>
                  </div>

                  <div class="display-node-content" *ngIf="isMilestoneExpanded(milestone)">
                    <dx-sortable
                      class="display-node-children-list"
                      [data]="milestone.taskPackages || []"
                      handle=".drag-handle"
                      (onReorder)="onTaskPackageReorder(milestone, $event)"
                      (onAdd)="onTaskPackageAdd(milestone, $event)"
                      (onRemove)="onTaskPackageRemove(milestone, $event)"
                      [allowDropInsideItem]="false"
                      [allowReordering]="true"
                      itemOrientation="vertical"
                      group="taskPackages"
                    >
                      @for (taskPackage of milestone.taskPackages || []; track taskPackage; let idx = $index) {
                        <app-setup-task-package-node
                          [taskPackage]="taskPackage"
                          [milestone]="milestone"
                          [phases]="phases"
                          [editing]="true"
                          [validationGroup]="validationGroup"
                          [allowDelete]="true"
                          (onDelete)="onTaskPackageDelete(milestone, $event)"
                        ></app-setup-task-package-node>
                      }
                    </dx-sortable>

                    <div class="create-button-container">
                      <app-gpd-button
                        i18n-text="@@addMoreTaskPackages"
                        text="Add More Task Packages"
                        icon="add"
                        type="secondary"
                        (onClick)="onTaskPackageCreate(milestone)"
                      ></app-gpd-button>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      }
    }
  </dx-scroll-view>

  <dx-validator [adapter]="taskPackageAdapterConfig">
    <dxi-validation-rule
      type="custom"
      [validationCallback]="taskPackageValidationCallback"
      i18n-message="@@taskPackageConfigInvalidValidationMessage"
      message="Task package configuration is invalid"
      style="display: none"
    ></dxi-validation-rule>
  </dx-validator>
</div>
